module.exports = __webpack_public_path__ + "fonts/fa-regular-400.7ab2cb05.woff";